import React from "react";
import { Translate } from "react-localize-redux";

// Helper component to render HTML content safely
const TranslateWithHTML = ({ id }) => {
  return (
    <Translate>
      {({ translate }) => <span dangerouslySetInnerHTML={{ __html: translate(id) }} />}
    </Translate>
  );
};

const DummyPlans = [
  {
    name: "Premium",
    type: "premium",
    description: "content.premium_desc",
    users: "1 хэрэглэгч",
    features: [
      "content.feature1",
      "content.feature2",
      "content.feature3",
      "content.feature4",
      "content.feature5",
      "content.feature6",
    ],
    price: "6,900₮",
    duration: "content.duration",
    highlight: false,
    discount: null,
    oldPrice: null,
    img: "/img/premium_img.png",
  },
  {
    name: "Premium Duo",
    type: "premium-duo",
    description: "content.premium_duo_desc",
    users: "2 хэрэглэгч",
    features: [
      "content.feature1",
      "content.feature2",
      "content.feature3",
      "content.feature4",
      "content.feature5",
      "content.feature6",
    ],
    price: "9,900₮",
    duration: "content.duration",
    highlight: true,
    discount: "-28%",
    oldPrice: "13,800₮",
    img: "/img/duo_image.png",
  },
  {
    name: "Premium Family",
    type: "premium-family",
    description: "content.premium_family_desc",
    users: "4 хэрэглэгч",
    features: [
      "content.feature1",
      "content.feature2",
      "content.feature3",
      "content.feature4",
      "content.feature5",
      "content.feature6",
    ],
    price: "17,900₮",
    duration: "content.duration",
    highlight: true,
    discount: "-35%",
    oldPrice: "27,600₮",
    img: "/img/family_image.webp",
  },
];

// Preload images
if (typeof window !== 'undefined') {
  DummyPlans.forEach((plan) => {
    const img = new Image();
    img.src = plan.img;
  });
}

const PricingPlans = React.memo(function PricingPlans(props) {
  const { plan, idx, onClick, eventBadge, buttonRef } = props;

  return (
    <div className="pricing-container wow fadeInUp">
      <div className="plan-card">
        <div className="plan-header">
          <div className="header-container">
            <h2>{plan.Name[1].Value}</h2>
            <div className="plan-img">
              <img src={DummyPlans[idx].img} alt={plan.Name[0].Value} loading="lazy" />
            </div>
          </div>
        </div>
        {/* Эвентийн тасалбарын баннер — зөвхөн Duo дээр
            (`components/Plans/plans.js`). Дарахад тасалбарын сайт руу.
            Figma 368:50 — гарчгийн ДАРАА, тайлбарын мөрний ӨМНӨ. */}
        {eventBadge && (
          <a
            className="plan-event-badge"
            href={eventBadge}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/img/event-badge-logo.png" alt="Doomsday" />
            <span className="plan-event-badge-label">
              <Translate id="content.event_ticket_badge" />
            </span>
            {/* Тасалбарын хөнгөлөлт — багцын хөнгөлөлтөөс ӨӨР зүйл.
                Хувь нь орчуулгын түлхүүрт (код засахгүйгээр солино). */}
            <span className="plan-event-badge-off">
              <Translate id="content.event_ticket_discount" />
            </span>
          </a>
        )}
        <div className="plan-description">
          <div className="plan-txt">
            <div className="description">
              <TranslateWithHTML id={DummyPlans[idx].description} />
            </div>
            <div className="users-count">
              {plan.MaxSharedUsers + 1} <Translate id="content.user" />
            </div>
          </div>
          {DummyPlans[idx].discount ? (
            <div className={`discount-circle`}>
              <span className="discount">{DummyPlans[idx].discount}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="plan-body">
          <ul>
            {DummyPlans[idx].features.map((f, i) => (
              <li key={i}>
                <Translate id={f} />
              </li>
            ))}
          </ul>

          <div className="plan-footer">
            <div className="price">
              {parseInt(plan.Cost)}₮{/* {DummyPlans[0].price} */}
              {DummyPlans[idx].discount ? (
                <>
                  {" "}
                  / <span className="old-price">{DummyPlans[idx].oldPrice}</span>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="duration">
              <Translate id={DummyPlans[0].duration} />
            </div>
            <button ref={buttonRef} onClick={onClick} className="buy-button">
              <Translate id="button.get-package" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PricingPlans;
